import { ActionTree, GetterTree, MutationTree } from 'vuex'
import enroll from '@/http/enroll'
import leads from '@/http/leads'
import zsb from '@/http/zsb'
import { State as Root } from '.'

export interface Item {
  id: number
  /**
   * 图片
   */
  image: string
  /**
   * 标题
   */
  title: string
  /**
   * 领取量
   */
  claims: number
  /**
   * 热度
   */
  pc: number
  /**
   * 二维码图片
   */
  qrCode?: string
  /**
   * vip使用权限
   */
  permission: number
}
export namespace Item {
  export const categories = [
    [0, '所有方案'],
    [9, '拼团'],
    [1, '小游戏'],
    [2, '报名模板'],
    [3, '分销'],
    [4, '砍价'],
    [5, '抽奖'],
    [6, '秒杀'],
    [7, '测一测'],
    [8, '投票']
  ]
}
/**
 * 筛选选项
 */
export interface FilterOptions {
  /**
   * 类别
   */
  category?: number
  /**
   * 标记
   */
  tag?: string
}

export interface State {
  /**
   * 机构ID
   */
  orgId?: string
  /**
   * 当前列表
   */
  items?: Item[]
  /**
   * 当前页索引
   */
  index?: number
  /**
   * 每页数量
   */
  size?: number
  /**
   * 当前列表总记录数
   */
  count?: number
  /**
   * 当前筛选项
   */
  filter?: FilterOptions
  /**
   * 是否被拉黑
   */
  blocked?: boolean
}
interface RawItem {
  id: number
  name: string
  coverImage: string
  receiveCount: number
  attendCount: number
  permission: number
}
interface RawList<T> {
  currentIndex: number
  totalCount: number
  list: T[]
}
export const state: Action<State> = () => ({
  orgId: null,
  index: 1,
  items: null,
  size: 10,
  count: null,
  blocked: null,
  filter: { category: 0, tag: null }
})

export const getters: GetterTree<State, Root> = {
  /**
   * 类别列表
   */
  categories: () => Item.categories.map(([k, v]) => ({ id: k, name: v }))
}

export const mutations: MutationTree<State> = {
  setOrg(state, { orgId, blocked }) {
    state.orgId = orgId
    state.blocked = blocked
  },
  setFilter(state, options: FilterOptions) {
    state.filter = options
  },
  setItems(state, items: Item[]) {
    state.items = items
  },
  endFetch(state, { items, index, count }) {
    state.items = items
    state.index = index
    state.count = count
  }
}

export const actions: ActionTree<State, Root> = {
  /**
   * 初始化
   *
   * @param orgId 机构ID
   */
  async init({ commit }, orgId?: string) {
    if (!orgId) {
      orgId = null
    }
    let blocked: boolean = true
    if (orgId) {
      const res: string = await leads.post('/config/getCommonConfigByShop', {
        configKey: 'erpzsb-banner',
        identityId: orgId,
        typeEnum: 'ERPORG'
      })
      blocked = res === '1'
    }
    commit('setOrg', { orgId, blocked })
  },

  /**
   * 获取数据列表
   *
   * @param index 页面索引
   */
  async fetch({ commit, state }, index?: number) {
    if (index == null) {
      index = 1
    }
    const res: RawList<RawItem> = await zsb.post('/getActivityexampleList', {
      basePageIbo: {
        pageIndex: index,
        pageSize: state.size
      },
      category: state.filter && state.filter.category,
      orgId: state.orgId,
      tag: state.filter && state.filter.tag
    })
    commit('endFetch', {
      index: res.currentIndex,
      items: res.list.map(e => ({
        id: e.id,
        image:
          e.coverImage ||
          'https://cdn.xiaobaoxiu.cn/xbshow/XcxImages/Common/load-fail.png',
        title: e.name,
        claims: e.receiveCount,
        pc: e.attendCount,
        qrCode: null,
        permission: e.permission
      })),
      count: res.totalCount
    })
  },

  /**
   * 过滤列表
   *
   * @param options 过滤参数
   */
  async filter({ commit, dispatch }, options?: FilterOptions) {
    commit('setFilter', options || { category: 0, tag: null })
    await dispatch('fetch', 1)
  },

  /**
   * 获取二维码
   *
   * @param index 方案索引
   */
  async fetchQrCode({ commit, state }, index: number) {
    const item = state.items && state.items[index]
    if (!item) {
      throw new Error('方案不存在')
    }
    if (item.qrCode) {
      return
    }
    const qrCode: string = await enroll.post('/portal/getExampleQrCode', {
      id: item.id
    })
    const items = Array.from(state.items)
    items.splice(index, 1, { ...item, qrCode })
    commit('setItems', items)
  },

  /**
   * 提交咨询
   */
  async submit({ state }, { type, form }) {
    if (!state.orgId) {
      throw new Error('机构信息缺失')
    }
    await zsb.post('/common/addERPConsultForm', {
      type,
      ...form,
      orgId: state.orgId
    })
  }
}

export const namespaced = true
